<!doctype html>
<section>
    <div class="row py-4 px-5 " style="background: #fff;margin: 0;">
        <div class="col-12 py-1  px-0">
            <h3>PROYECTOS</h3>
        </div>
    
        <div class="col-12  py-1  px-0">
            <h4
             style="text-align: center;">
             <em><i>Todos - Angular - <b>JavaScript</b> - maquetas</i></em>
                 </h4>
        </div>
      
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 py-3  px-0" *ngFor="let project of projects">
            <div class="project-container-general">
                <h5 class="name-project"><b>{{ project.name }}</b></h5>
                <img src="{{ project.srcImg }}" alt="imagen del proyecto" class="img-fluid representation-img-project">
    
                <ul style="list-style:none;">
                   
    
               
                    <li class="mt-3">
                        <ul style="display: flex; justify-content: space-evenly;">
                            <li class="btn btn-outline" style="display: inline-flex;"> <a href="{{ project.demo }}" target="_blank">Demo</a></li>
                            <li class="btn btn-outline" style="display: inline-flex;"> <a href="{{ project.srcGithub }}"  target="_blank">Github</a></li>
                        </ul>
                    </li>
                    <li class="mt-3 li-description"><b>Tecnologias :</b><br>{{ project.tecnology }}</li>
                    <li class="li-description"><b>Estilos :</b><br> {{ project.style }}</li>
                    <li class="li-description"><b>Framework :</b><br> {{ project.framework }}</li>
                </ul>
    
            </div>
    
        </div>
    
    </div> 
</section>






